import { ImageFragment } from '@/graphql/fragments/image';
import { gql } from '@apollo/client';

export const QUERY_CURRENT_MINDFUL_MINUTE = gql`
  query currentMindfulMinute($date: DateFilterInput) {
    mindfulMinutes(filters: { date: $date }) {
      data {
        id
        attributes {
          date
          type
          calmBreathing {
            title
            prompt
            spokenGuidance {
              data {
                attributes {
                  name
                  url
                }
              }
            }
          }
          prompt {
            title
            prompt
            durationInSeconds
          }
          video {
            videoTitle
            video {
              data {
                attributes {
                  name
                  url
                  height
                  width
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_MINDFUL_MINUTE_PAGE = gql`
  query mindfulMinutePage {
    mindfulMinutePage {
      data {
        attributes {
          CalmBreathingPage {
            thankYouTitle
            backDailyBubbleButton
            minutes {
              id
              minute
            }
            playButtonLabel
            pauseButtonLabel
            stopButtonLabel
          }
          QuotePage {
            backDailyBubbleButton
            startExerciseButton
            thankYouTitle
            playButtonLabel
            pauseButtonLabel
            stopButtonLabel
            restartButtonLabel
          }
          VideoPage {
            backDailyBubbleButton
            thankYouTitle
          }
          relatedContentViewAllLabel
          relatedContentTitle
          relatedContent {
            data {
              attributes {
                topic
              }
            }
          }
          onboarding {
            steps {
              title
              description
              textBtn
              image {
                data {
                  ...ImageFragment
                }
              }
            }
          }
          mindfulExerciseRelatedContent {
            data {
              id
              attributes {
                title
                subHeader
                slug
                duration
                briefDescription
                type
                mindful_exercise_type {
                  data {
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
